/**
 * 开发环境优先使用 .env 中的 VUE_APP_BASE_URL，便于本地对接本机后端；
 * 生产构建后优先使用 public/config.js 的 window.APP_CONFIG，便于 IIS 部署修改。
 */
export function resolveApiBaseUrl() {
  const fromWindow =
    typeof window !== 'undefined' &&
    window.APP_CONFIG &&
    window.APP_CONFIG.apiBaseUrl
      ? String(window.APP_CONFIG.apiBaseUrl).trim()
      : ''

  const fromEnv =
    typeof process !== 'undefined' &&
    process.env &&
    (process.env.VUE_APP_BASE_URL || process.env.BASE_URL)
      ? String(process.env.VUE_APP_BASE_URL || process.env.BASE_URL).trim()
      : ''

  const isDev =
    typeof process !== 'undefined' &&
    process.env &&
    process.env.NODE_ENV === 'development'

  if (isDev && fromEnv) {
    return fromEnv
  }

  return fromWindow || fromEnv || ''
}
